module.exports = __webpack_public_path__ + "front/img/sub-img-2.c1bef6f0.png";